<template>
  <ModalDialog
    ref="dialog"
    title="Update Automation Rule"
    icon="fa-rocket"
    sizeClass="modal-lg"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="ruleForm">
      <FormRow label="Name">
        <FormInputText v-model="ruleData.name" placeholder="Automation Rule Name" />
      </FormRow>
      <FormRow label="Description">
        <FormInputText v-model="ruleData.description" placeholder="Automation Rule Description" />
      </FormRow>
      <FormRow label="Enabled">
        <FormCheckbox v-model="ruleData.isActive" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'AutomationEditDialog',
  mixins: [form, ModalDialogMixin],
  components: {
    ModalDialog
  },
  props: {
    autoRule: Object
  },
  data: () => {
    return {
      ruleData: {},
      ruleForm: {},
      submitting: false,
    };
  },
  methods: {
    show(options = {}) {
      // Reset form
      this.ruleForm = { }
      
      this.ruleData = _.cloneDeep(this.autoRule)

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var updateData = {
        name: this.ruleData.name,
        description: this.ruleData.description,
        isActive: this.ruleData.isActive
      }

      this.submitting = true
      this.ruleForm = this.clearFormResponse()

      this.$apiService.automationService.updateAutomationRule(this.autoRule.id, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.ruleForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })      
    },
  }

}
</script>